export default ({ request }) => ({
  ecomShipmentGoodsListApi(data = {}) {
    return request({
      url: '/ecom/shipment/goods/list',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentGoodsDetailApi(data = {}) {
    return request({
      url: '/ecom/shipment/goods/detail',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentGoodsSaveCustomsApi(data = {}) {
    return request({
      url: '/ecom/shipment/goods/saveCustoms',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentGoodsListContainerPoolApi(data = {}) {
    return request({
      url: '/ecom/shipment/goods/listContainerPool',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentGoodsContainerPoolStatsApi(data = {}) {
    return request({
      url: '/ecom/shipment/goods/containerPoolStats',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
})
